/* MINIFLACONS Duft-Finder · Konzentration (Metafeld custom.konzentration) neben der Marke auf den Ergebnis-Karten */
(function(){
  "use strict";
  var R=document.getElementById("mfq");if(!R)return;
  var M=null;
  function map(){
    if(M)return M;var m={},n=0;
    try{for(var i=0;i<sessionStorage.length;i++){var k=sessionStorage.key(i);if(!k||k.indexOf("mfq_data_")!==0)continue;
      var c=JSON.parse(sessionStorage.getItem(k)||"null");if(!c||!Array.isArray(c.p))continue;
      c.p.forEach(function(x){if(x&&x.url&&x.kz&&!m[x.url]){m[x.url]=x.kz;n++}})}}catch(e){}
    if(n)M=m;return n?m:null;
  }
  function run(){
    var m=map();if(!m)return;
    R.querySelectorAll("b>a[href]").forEach(function(a){
      var s=a.parentNode.previousElementSibling;if(!s||s.tagName!=="SMALL"||s.hasAttribute("data-kz"))return;
      var kz=m[a.getAttribute("href")];if(!kz)return;
      s.setAttribute("data-kz","1");s.appendChild(document.createTextNode(" · "+kz));
    });
  }
  try{new MutationObserver(run).observe(R,{childList:true,subtree:true})}catch(e){}
  run();
})();
